import { render, staticRenderFns } from "./jt808-sendcmd-detail-modal.vue?vue&type=template&id=56b08345"
import script from "./jt808-sendcmd-detail-modal.vue?vue&type=script&lang=js"
export * from "./jt808-sendcmd-detail-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports